module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.3a78125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/fullscreen-image_hero_768.png
// module id = 7Ls4
// module chunks = 0